module.exports = __webpack_public_path__ + "static/media/start_screen.a29b4893.png";